import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  uploadInfoContainer: {
    display: 'flex',
    flex: '1',
    padding: '0px',
    '@media (min-width: 640px)': {
      padding: '16px 24px',
    },
    backgroundColor: theme.evPalette.charcoal[100],
  },
  uploadInfoContainerPaper: {
    display: 'flex',
    flex: '1 1 auto',
    padding: '16px 24px',
    justifyContent: 'center',
    borderRadius: '0px',
    '@media (min-width: 640px)': {
      padding: '24px',
      borderRadius: '4px',
    },
  },
  blueprintInfoBox: {
    display: 'flex',
    borderRadius: '4px',
    flexDirection: 'column',
    backgroundColor: '#F0F2F7',
    padding: '16px',
    gap: '16px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  uploadInfoContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    '@media (min-width: 908px)': {
      width: '70%',
    },
  },
  alertContainer: {
    display: 'flex',
    height: 'fit-content',
    gap: '16px',
    backgroundColor: theme.evPalette.mango[100],
    '&>.myev-MuiAlert-icon': {
      padding: '10px 0',
      color: theme.evPalette.mango[700],
      justifyContent: 'center',
      margin: '0px',
    },
  },
  redirectionLinksContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  redirectionLinkText: {
    display: 'inline',
    fontSize: '14px',
  },
  redirectionButtonStyles: {
    color: theme.evPalette.ocean[600],
    fontSize: '14px',
    padding: '0px',
    display: 'inline-block',
    marginTop: '-2px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  uploadBlueprintContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '0px',
    marginTop: '8px',
  },
  submitButton: {
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'fit-content',
    },
  },
}));
